import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Location',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }
        },
        [h("circle", {
          attrs: { cx: "12", cy: "12", r: "5.1" }
        }), h("line", {
          attrs: { x1: "12", y1: "6.9", x2: "12", y2: "4" }
        }), h("line", {
          attrs: { x1: "6.9", y1: "12", x2: "4", y2: "12" }
        }), h("line", {
          attrs: { x1: "12", y1: "17.1", x2: "12", y2: "20" }
        }), h("line", {
          attrs: { x1: "17.1", y1: "12", x2: "20", y2: "12" }
        })]
      )]
    );
  }
};